import React from "react";
import { Button } from "antd";
import {
  FolderAddOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";

export default function HadoopToolbar({
  onCreateDirectory,
  onDeleteDirectory,
  onUploadFile,
  isRoleUser,
}) {
  if (isRoleUser) return null;

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      <Button
        type="primary"
        icon={<FolderAddOutlined />}
        onClick={onCreateDirectory}
        style={{ backgroundColor: "#D97A07", border: "none" }}
      >
        Create Directory
      </Button>

      <Button
        danger
        type="primary"
        icon={<DeleteOutlined />}
        onClick={onDeleteDirectory}
        style={{ backgroundColor: "#a71e27", border: "none" }}
      >
        Delete Directory
      </Button>

      <div style={{ marginLeft: "auto" }}>
        <Button
          type="primary"
          icon={<UploadOutlined />}
          onClick={onUploadFile}
          style={{ backgroundColor: "#0D2E4D", border: "none" }}
        >
          Upload File
        </Button>
      </div>
    </div>
  );
}
